import { singleton } from "tsyringe";

@singleton()
export class ListenMessageHandler {
    /**
     * @description
     * 팝업이 닫힐 때의 메시지를 전달 받습니다.
     * @param {Window} popup 팝업
     * @param {MessageEvent} event 메시지 이벤트
     */
    public handler = (popup: Window) => (event: MessageEvent) => {
        if (event.origin !== import.meta.env.VITE_COMMON_ACCOUNTS_URL) return;

        const parseData = JSON.parse(event.data);

        if (parseData.userDto) {
            console.log(parseData.userDto);
        }

        popup.close();
        window.removeEventListener("message", this.handler(popup));
    };

    /**
     * @description
     * 메시지 이벤트 리스너를 추가합니다.
     * @param {Window} popup 팝업
     */
    public listen = (popup: Window) => {
        window.addEventListener("message", this.handler(popup));
    };
}
